import { Box, Typography, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { FilterLoadingProps } from "../api/types";


const FilterLoading = ({ displayLabel }: FilterLoadingProps) => {
  const [dots, setDots] = useState("");

  // Animate dots: "", ".", "..", "..."
  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length === 3 ? "" : prev + "."));
    }, 450);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 1400,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        pointerEvents: "all",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          px: 4,
          py: 3,
          borderRadius: 3,
          backgroundColor: "#020617",
          boxShadow: "0px 30px 80px rgba(0, 0, 0, 0.8)",
        }}
      >
        <CircularProgress
          size={30}
          thickness={4}
          sx={{ color: "#38bdf8" }}
        />

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Typography fontWeight={600} color="#f8fafc">
            Filtering Data{dots}
          </Typography>

          <Typography fontSize={14} color="#94a3b8">
            {displayLabel}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default FilterLoading;
